export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6327.284da6d3.jpg";